import type { ReportConfigurationType } from '@api';
import type { EditReportMailingFormValuesType } from '../../types';

export const mapVenueReportMailingToFormValues = (
  mailing: ReportConfigurationType
): EditReportMailingFormValuesType => {
  const [sendHour, sendMinute] = mailing.sendTime.split(':');

  return {
    label: mailing.label,
    isEnabled: mailing.isEnabled,
    recipientGroupId:
      mailing.configurationOptions.kind === 'VENUE'
        ? (mailing.configurationOptions.recipientGroup?.id ?? null)
        : null,
    sendWeekday: mailing.sendWeekday,
    sendHour,
    sendMinute,
    locale: mailing.locale,
    profileNote: mailing.profileNote ?? '',
    internalNote: mailing.internalNote ?? '',
  };
};
